module.exports = __webpack_public_path__ + "img/2.1222e495.png";